export default "__VITE_PUBLIC_ASSET__62dea133__"